module.exports = __webpack_public_path__ + "static/media/es-flag.d5c36a87.svg";